import List from './List'
import Card from './Card'
import Details from './Details'

export default {
  List,
  Card,
  Details  
}